import { render } from "./ContentPdf.vue?vue&type=template&id=67f88572&scoped=true"
import script from "./ContentPdf.vue?vue&type=script&lang=js"
export * from "./ContentPdf.vue?vue&type=script&lang=js"

import "./ContentPdf.vue?vue&type=style&index=0&id=67f88572&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f88572"]])

export default __exports__